module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "splash"
  }, [_c('div', {
    staticClass: "parallax"
  }, [_c('div', {
    staticClass: "logo back"
  }), _vm._v(" "), _c('div', {
    staticClass: "logo front"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h2"
  }, [_c('div', {
    staticClass: "inset bg-alt text-bg"
  }, [_vm._v("Ubercharged Gaming")])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._v("Coming soon™")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://discord.gg/0140zAqXoEaHJKmnX"
    }
  }, [_vm._v("Discord")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://steamcommunity.com/groups/ubrgmg"
    }
  }, [_vm._v("Steam")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2660219a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 28
// module chunks = 0